import { render, staticRenderFns } from "./StockPersonStatisticsNew.vue?vue&type=template&id=2d756bce&"
import script from "./StockPersonStatisticsNew.vue?vue&type=script&lang=ts&"
export * from "./StockPersonStatisticsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports